import { Banner } from "@shopify/polaris";

import { t } from "../lib/i18n";

interface QueryErrorBannerProps {
  /** 取得に失敗したデータ名（例: "在庫分析"）。省略時は一般的な文言のみ。 */
  title?: string;
  /** React Query の refetch。押すと再取得する。 */
  onRetry: () => void;
}

/**
 * データ取得失敗の共通バナー。原因（通信・一時的な障害など）は画面からは特定
 * できないため理由を断定せず、行き止まりにしないよう必ず「再試行」を出す。
 * 文言・再試行の挙動は Home のエラーバナーと統一する。
 * ⚠️ 旧文言は「初回アクセスはサーバーの起動に数秒かかる」と説明していたが、
 *    backend は v66（2026-07-17）から常時1台稼働＝コールドスタートは起きない。
 */
export function QueryErrorBanner({ title, onRetry }: QueryErrorBannerProps) {
  return (
    <Banner
      tone="critical"
      title={title}
      action={{ content: t("再試行"), onAction: onRetry }}
    >
      {t("サーバーへの接続に失敗しました。通信環境を確認し、「再試行」を押してください。解消しない場合は時間をおいて再度お試しください。")}
    </Banner>
  );
}
